import AGREGAR_AUDITORIA_INFORME_RESPUESTA from '@/graphql/mutations/administracion/auditorias/respuestas/agregarAuditoriaInformeRespuesta.gql';
import ELIMINAR_AUDITORIA_INFORME_RESPUESTA from '@/graphql/mutations/administracion/auditorias/respuestas/removerAuditoriaInformeRespuesta.gql';
import ACTUALIZAR_AUDITORIA_INFORME_RESPUESTA from '@/graphql/mutations/administracion/auditorias/respuestas/actualizarAuditoriaInformeRespuesta.gql';
import AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/agregarAuditoriaInformeRespuestaDetalle.gql';
import ELIMINAR_AUDITORIA_INFORME_RESPUESTA_DETALLE from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/removerAuditoriaInformeRespuestaDetalle.gql';
import ACTUALIZAR_AUDITORIA_INFORME_RESPUESTA_DETALLE from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/actualizarAuditoriaInformeRespuestaDetalle.gql';
import AUDITORIA_INFORME_RESPUESTAS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestas.gql';
import AUDITORIA_INFORME from '@/graphql/querys/administracion/auditorias/auditoriaInforme.gql';
import AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestaDetalleDocumentos.gql';
import REMOVER_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/documentos/removerAuditoriaInformeRespuestaDetalleDocumento.gql';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  mixins: [mixSubirArchivo],
  apollo: {
    auditoriaInforme: {
      query: AUDITORIA_INFORME,
      variables() {
        return {
          id: this.$route.params.idInforme,
        };
      },
    },
  },
  methods: {
    async mixAgregarRespuesta() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const idInforme = this.informe.id;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_RESPUESTA,
          variables: { respuesta: this.respuesta },
          update: (store, { data: { agregarAuditoriaInformeRespuesta } }) => {
            const query = {
              query: AUDITORIA_INFORME_RESPUESTAS,
              variables: { idInforme },
            };
            const { auditoriaInformeRespuestas } = store.readQuery(query);
            const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
            auditoriaInformeRespuestasCopia.push(agregarAuditoriaInformeRespuesta);
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEditarRespuesta() {
      const { idInforme } = this.respuestaEditar;
      const { id } = this.respuestaEditar;
      const { respuesta } = this;
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_AUDITORIA_INFORME_RESPUESTA,
        variables: {
          id,
          respuesta,
        },
        update: (store, { data: { actualizarAuditoriaInformeRespuesta } }) => {
          const query = {
            query: AUDITORIA_INFORME_RESPUESTAS,
            variables: { idInforme },
          };
          const { auditoriaInformeRespuestas } = store.readQuery(query);
          const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
          const index = auditoriaInformeRespuestasCopia
            .findIndex((o) => o.id === actualizarAuditoriaInformeRespuesta.id);
          if (index !== -1) {
            auditoriaInformeRespuestasCopia
              .splice(index, 1, actualizarAuditoriaInformeRespuesta);
          }
          store.writeQuery({
            ...query,
            data: {
              auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarRespuesta() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idRespuesta = this.respuesta.id;
      const { idInforme } = this.respuesta;
      await this.$apollo.mutate({
        mutation: ELIMINAR_AUDITORIA_INFORME_RESPUESTA,
        variables: {
          id: idRespuesta,
        },
        update: (store) => {
          const query = {
            query: AUDITORIA_INFORME_RESPUESTAS,
            variables: { idInforme },
          };
          const { auditoriaInformeRespuestas } = store.readQuery(query);
          const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
          const index = auditoriaInformeRespuestasCopia
            .findIndex(({ id }) => id === idRespuesta);
          if (index !== -1) {
            auditoriaInformeRespuestasCopia.splice(index, 1);
          }
          store.writeQuery({
            ...query,
            data: {
              auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixGetPdf(publicKey) {
      return this.axios.get(
        `${BASE_URL}/${publicKey}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => ({
          data: res.data,
        }))
        .catch((err) => {
          this.mixMensajeError(err.data.message);
          return {
            err: err.data.message,
          };
        });
    },
    async mixAgregarRespuestaDetalle() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const idInforme = this.informe.id;
      const detalles = this.respuestaDetalles;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE,
          variables: { detalles },
          update: (store, { data: { agregarAuditoriaInformeRespuestaDetalle } }) => {
            const query = {
              query: AUDITORIA_INFORME_RESPUESTAS,
              variables: { idInforme },
            };
            const { auditoriaInformeRespuestas } = store.readQuery(query);
            const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
            const respuestaEncontrada = auditoriaInformeRespuestasCopia
              .find(({ id }) => id === this.respuesta.id);
            respuestaEncontrada.detalles.push(...agregarAuditoriaInformeRespuestaDetalle);
            const index = auditoriaInformeRespuestasCopia
              .findIndex(({ id }) => id === respuestaEncontrada.id);
            if (index !== -1) {
              auditoriaInformeRespuestasCopia.splice(index, 1, respuestaEncontrada);
            }

            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
              },
            });
            // EVALUAR RESPUESTAS-DETALLES PARA ACTUALIZAR ESTATUS OBSERVACION
            this.actualizarEstatusObservacion(
              this.getEvaluarRespuestas()
                .filter((respuesta) => respuesta.enviadasCompletas === true
              && (respuesta.estatus === 'PENDIENTE' || respuesta.estatus === 'POR RESPONDER'
              || respuesta.estatus === 'RESPUESTA ENVIADA PARCIAL')), 'RESPUESTA ENVIADA COMPLETA',
            );
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      await this.$apollo.queries.auditoriaInforme
        .refetch();
      this.cerrar();
    },
    async mixEliminarRespuestaDetalle() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idDetalle = this.respuestaDetalle.id;
      const idObservacionDetalle = this.respuestaDetalle.idAuditoriaInformeObservacionDetalle;
      const idRespuesta = this.respuestaDetalle.idAuditoriaInformeRespuesta;
      const { idInforme } = this.respuesta;
      const desgloseEsRespuestaParcial = this.respuestaDetalle.esRespuestaParcial;
      await this.$apollo.mutate({
        mutation: ELIMINAR_AUDITORIA_INFORME_RESPUESTA_DETALLE,
        variables: {
          id: idDetalle,
          idObservacionDetalle,
          desgloseEsRespuestaParcial,
        },
        update: (store) => {
          const query = {
            query: AUDITORIA_INFORME_RESPUESTAS,
            variables: { idInforme },
          };
          const { auditoriaInformeRespuestas } = store.readQuery(query);
          const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();

          const respuesta = auditoriaInformeRespuestasCopia
            .find(({ id }) => id === idRespuesta);
          let index = respuesta.detalles
            .findIndex((d) => d.id === idDetalle);
          if (index !== -1) {
            respuesta.detalles
              .splice(index, 1);
          }
          index = auditoriaInformeRespuestasCopia
            .findIndex(({ id }) => id === respuesta.id);
          if (index !== -1) {
            auditoriaInformeRespuestasCopia.splice(index, 1, respuesta);
          }
          store.writeQuery({
            ...query,
            data: {
              auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      await this.$apollo.queries.auditoriaInforme
        .refetch();
      this.mixEsCargando();
      // this.cerrar();
    },
    async mixEditarRespuestaDetalle() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const idInforme = this.informe.id;
      const idRespuesta = this.respuestaDetalleEditar.idAuditoriaInformeRespuesta;
      const idDetalle = this.respuestaDetalleEditar.id;
      const detalle = this.respuestaDetalle;
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_AUDITORIA_INFORME_RESPUESTA_DETALLE,
          variables: {
            id: idDetalle,
            detalle,
          },
          update: (store, { data: { actualizarAuditoriaInformeRespuestaDetalle } }) => {
            const query = {
              query: AUDITORIA_INFORME_RESPUESTAS,
              variables: { idInforme },
            };

            const { auditoriaInformeRespuestas } = store.readQuery(query);
            const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();

            const respuesta = auditoriaInformeRespuestasCopia
              .find(({ id }) => id === idRespuesta);
            let index = respuesta.detalles
              .findIndex((d) => d.id === idDetalle);
            if (index !== -1) {
              respuesta.detalles
                .splice(index, 1, actualizarAuditoriaInformeRespuestaDetalle);
            }
            index = auditoriaInformeRespuestasCopia
              .findIndex(({ id }) => id === respuesta.id);
            if (index !== -1) {
              auditoriaInformeRespuestasCopia.splice(index, 1, respuesta);
            }
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      // this.cerrar();
    },
    // Eliminar Detalle Documentos
    async mixEliminarDetalleDocumentos() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      this.respuestaDetalle.documentos.forEach(
        async (documento) => {
          await this.$apollo.mutate({
            mutation: REMOVER_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO,
            variables: {
              id: documento.id,
            },
            update: (store) => {
              const query = {
                query: AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS,
                variables: {
                  idAuditoriaInformeRespuestaDetalle: documento
                    .idAuditoriaInformeRespuestaDetalle,
                },
              };
              const data = store.readQuery(query);
              const { auditoriaInformeRespuestaDetalleDocumentos } = data;
              const index = auditoriaInformeRespuestaDetalleDocumentos
                .findIndex((respuestaDetalleDocumento) => respuestaDetalleDocumento.id
                === documento.id);
              if (index !== -1) {
                auditoriaInformeRespuestaDetalleDocumentos.splice(index, 1);
              }
              store.writeQuery({ ...query, data });
            },
          }).then(() => {
            this.mixMensajeSuccess();
          }).catch((err) => {
            this.mixMensajeError(err);
          });
        },
      );

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
